import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() { }

  // Check if the user is logged in
  isLoggedIn(): boolean {
    // Assume a token is stored in localStorage when the user logs in
    return !!localStorage.getItem('token'); // You can adjust this based on how you store the token
  }

  // Log out the user (optional)
  logout() {
    localStorage.removeItem('token'); // Clear the token to log the user out
  }
}
